/* eslint-disable react/no-danger */
/* eslint-disable react/no-unknown-property */
import React, { useRef, useState } from "react"

import { css } from "@jsUtils"
import Styles from "./accordion.module.scss"
import { Circle } from "../Circle"

/**
 * Render an accordion
 * Note this provides basic layout and funcionality -- the best current styled implementation is Support FAQs
 * @param {object} props - react props
 * @param {string} props.summary - summary content
 * @param {string} props.insideStyle - style to apply to wrapper around content
 * @param {boolean} props.bindEvent - do we bind the click events?
 * @param {array} props.children - child items to render / content
 * @param {string} props.useMarkup - do we use HTML markup or no?
 * @param {COLORS.BLUE|COLORS.FLURO|COLORS.WORKS} props.color - plus/minus button color
 */
const Accordion = props => {
  const { color, summary, insideStyle, children, useMarkup } = props

  const summaryButton = useRef(null)
  const [open, setOpen] = useState(false)

  const toggleOpen = () => {
    setOpen(!open)
  }

  return (
    <div ascope="CTAS" adata="MISC.SUPPORT" className={css(Styles.root, open && Styles.open)}>
      <summary ref={summaryButton} onClick={toggleOpen}>
        <span className={Styles.summaryText}>{summary}</span>
        <Circle
          color={color}
          className={Styles.circleButton}
          content="plus"
          label="Expand"
          inverseSymbol={open}
          size="small"
        />
      </summary>
      <div className={Styles.inside}>
        <div className={css(Styles.insideInner, insideStyle)}>
          {useMarkup && !children && (
            <div className={Styles.body} dangerouslySetInnerHTML={{ __html: useMarkup }} />
          )}
          {!useMarkup && children && <div className={Styles.body}>{children}</div>}
        </div>
      </div>
    </div>
  )
}

export default Accordion
